<template>
  <div class="accordion" id="accordionPanelsStayOpenExample">
  <div class="content-wrap">
      <!-- 그리드 영역 시작 -->
      <div class="table-responsive table-cf">
        <TabView @tab-change="onTabChange">
          <TabPanel header="전체합계">
            <TotalSumComponent v-if="state.activeIndex === 0"/>
          </TabPanel>
          <TabPanel header="영업대표별" v-if ="!state.groupAuth">
            <SalesCeoComponent v-if="state.activeIndex === 1"/>
          </TabPanel>
          <TabPanel header="영업기회별">
            <SalesComponent v-if="state.activeIndex === 2"/>
          </TabPanel>
        </TabView>
      </div>
      <!-- 그리드 영역 종료 -->
      <div class="text-end py-2">
      </div>
    </div>
  </div>
  <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#msgModal" ref="msgModalRef"/>
</template>

<script setup>   
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import TotalSumComponent from '@/components/TotalSumComponent.vue'
import SalesCeoComponent from '@/components/SalesCeoComponent.vue'
import SalesComponent from '@/components/SalesComponent.vue'
import { reactive,onBeforeMount } from 'vue';

import { useUserStore } from '@/store/user'
const userStore = useUserStore()

onBeforeMount(() => {
  state.groupAuth = ['C'].includes(userStore.user.authGrpId)
})

const state = reactive({
  activeIndex : 0,
  groupAuth : true
})

const onTabChange = (event) =>{
  state.activeIndex = event.index;
  if(state.groupAuth && state.activeIndex === 1){
    state.activeIndex = 2
  }
}

</script>
